import { ActivatedRouteSnapshot, ResolveFn, Router, UrlTree } from '@angular/router'

import { AuthService } from '@core/service/auth.service'
import { inject } from '@angular/core'

/**
 * The attempt to navigate to login after user is authenticated.
 */

export const isLoggedInGuard: ResolveFn<boolean | UrlTree> = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  const isAuthenticated = authService.isAuthenticated()

  if (!isAuthenticated && !route.routeConfig.data?.disabledAuthorizationCheck) {
    return router.navigate(['/login'])
  }
  if (
    isAuthenticated &&
    route.routeConfig.data?.disabledAuthorizationCheck &&
    route.routeConfig.data?.redirectToScopes
  ) {
    return router.navigate(['/scopes'])
  }

  return true
}
